/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetMerchantUnitOvertimeRulesetRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {BatchGetMerchantUnitOvertimeRulesetResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const batchGetMerchantUnitOvertimeRuleset = (request: BatchGetMerchantUnitOvertimeRulesetRequest, options?: CashRequestOptions) => post<BatchGetMerchantUnitOvertimeRulesetRequest, BatchGetMerchantUnitOvertimeRulesetResponse>("/proxy/services/squareup.timecards.TimeCalculationService/BatchGetMerchantUnitOvertimeRuleset", request, {...options, rejectOnError: true })